/**
 * 路由配置文件
 * 徐杰
 * 2019-6-2
 **/
import Vue from 'vue';
import Router from 'vue-router';

// 引用页面文件
import index from './pages/index.vue';
import login from './pages/login.vue';
import Layout from './layout';

Vue.use(Router);

const router = new Router({
  // mode: 'history', // 去除路径#
  routes: [
    {
      path: '*',
      redirect: 'login',
      hidden: true, // 是否在菜单隐藏
    },
    {
      path: '/', // 默认去主页
      redirect: 'home',
      hidden: true,
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      hidden: true,
    },
    {
      path: '/home',
      name: 'home',
      component: Layout,
      redirect: '/home/index',
      meta: {
        title: '系统首页',
        icon: 'icon iconfont icon-xitong',
      },
      children: [
        {
          path: 'index',
          component: index,
        },
      ],
    },
    {
      path: '/CSsystem',
      name: 'CSsystem',
      component: Layout,
      redirect: '/CSsystem/index',
      meta: {
        icon: 'icon iconfont icon-gongkuangtu',
        title: '浏览工况系统',
      },
      children: [
        {
          path: 'index',
          name: 'CSsystemIndex',
          component: () => import('./pages/CSsystem/CSsystem.vue'), // 工况系统
        },
      ],
    },
    {
      path: '/online',
      name: 'onlineIndex',
      component: Layout,
      redirect: '/online/index',
      meta: {
        icon: 'icon iconfont icon-yangan',
        title: '浏览在线系统',
      },
      children: [
        {
          path: 'index',
          name: 'online',
          component: () => import('./pages/onlinesystem/onlinesystem.vue'), // 在线系统列表
        },
      ],
    },
    {
      path: '/Lampblack',
      name: 'Lampblack',
      component: Layout,
      redirect: '/Lampblack/index',
      meta: {
        icon: 'icon iconfont icon-youyanji',
        title: '浏览油烟系统',
      },
      children: [
        {
          path: 'index',
          name: 'LampblackIndex',
          component: () => import('./pages/Lampblack/Lampblack.vue'), // 工况系统
        },
      ],
    },

    {
      path: '/raisedust',
      name: 'raisedust',
      component: Layout,
      redirect: '/raisedust/realTime',
      meta: {
        icon: 'icon iconfont icon-yangchen1',
        title: '扬尘在线监测',
      },
      children: [
        {
          path: '/raisedust/realTime',
          name: 'realTime',
          meta: {
            icon: 'icon iconfont icon-yangchen',
            title: '实时监控',
          },
          component: () => import('./pages/raisedust/realTime/realTime.vue'), // 扬尘系统
        },
        {
          path: '/raisedust/callPolice',
          name: 'callPolice',
          meta: {
            icon: 'icon iconfont icon-baojing1',
            title: '报警管理',
          },
          component: () => import('./pages/raisedust/callPolice/callPolice.vue'), // 扬尘系统
        },
        {
          path: '/raisedust/history',
          name: 'history',
          meta: {
            icon: 'icon iconfont icon-lishijilu2',
            title: '历史记录',
          },
          component: () => import('./pages/raisedust/history/history.vue'), // 扬尘系统
        },
      ],
    },
    // {
    //   path: "/videos",
    //   name: "videos",
    //   component: Layout,
    //   redirect: "/videos/index",
    //   meta: {
    //     icon: "icon iconfont icon-jiankong",
    //     title: "浏览视频系统",
    //   },
    //   children: [
    //     {
    //       path: "index",
    //       component: () => import("./pages/videos/videos.vue"), // 视频列表
    //     },
    //   ],
    // },
    {
      path: '/historys',
      name: 'historys',
      component: Layout,
      redirect: '/historys/index',
      meta: {
        icon: 'icon iconfont icon-baojing1',
        title: '历史报警记录',
      },
      children: [
        {
          path: 'index',
          component: () => import('./pages/policecord/historys.vue'), // 报警记录查看
        },
      ],
    },
    {
      path: '/complist',
      name: 'complist',
      component: Layout,
      redirect: '/complist/index',
      meta: {
        icon: 'icon iconfont icon-qiye',
        title: '企业列表',
      },
      children: [
        {
          path: 'index',
          component: () => import('./pages/company/complist.vue'), // 企业列表
        },
      ],
    },
    {
      path: '/system',
      name: 'system',
      component: Layout,
      meta: {
        permission: 2, // 允许权限为2的人员访问显示
        icon: 'icon iconfont icon-xitonghoutai',
        title: '系统管理',
      },
      children: [
        {
          path: '/system/adminlist',
          name: 'adminlist',
          meta: {
            icon: 'icon iconfont icon-qiye',
            title: '企业管理',
          },
          component: () => import('./pages/systemmanage/admin/adminlist.vue'), // 管理员列表
        },
        {
          path: '/system/Street',
          name: 'Street',
          meta: {
            icon: 'icon iconfont icon-quyu',
            title: '街道管理',
          },
          component: () => import('./pages/systemmanage/Street/Streetlist.vue'), // 管理员列表
        },
        {
          path: '/system/dictiona',
          name: 'dictiona',
          meta: {
            icon: 'icon iconfont icon-bianma',
            title: '编码字典',
          },
          component: () => import('./pages/systemmanage/dictiona/dictiona.vue'), // 编码字典
        },
        {
          path: '/system/Jurisdiction',
          name: 'Jurisdiction',
          meta: {
            icon: 'icon iconfont icon-quanxian',
            title: '多权限账户管理',
          },
          component: () => import('./pages/Jurisdiction/Jurisdiction.vue'), // 权限信息
        },
        // {
        //   path: '/system/systemDescription',
        //   name: 'systemDescription',
        //   meta: {
        //     icon: 'icon iconfont icon-shuo',
        //     title: '系统说明',
        //   },
        //   component: () => import('./pages/systemDescription/systemDescription.vue'), // 修改系统说明
        // },
        // {
        //   path: "/system/feedback",
        //   name: "feedback",
        //   meta: {
        //     icon: "icon iconfont icon-message1",
        //     title: "反馈列表",
        //   },
        //   component: () => import("./pages/feedback/feedback.vue"),
        // },
        {
          path: '/proinfo/prolist',
          name: 'prolist',
          meta: {
            icon: 'icon iconfont icon-message1',
            title: 'pro列表',
          },
          component: () => import('./pages/proinfo/proLisy.vue'),
        },
        {
          path: '/proinfo/addpro',
          name: 'addpro',
          hidden: true,
          component: () => import('./pages/proinfo/addpro.vue'), // pro添加
        },
        {
          path: '/proinfo/updataPro',
          name: 'updataPro',
          hidden: true,
          component: () => import('./pages/proinfo/updataPro.vue'), // pro修改
        },
        {
          path: '/system/newshebei',
          name: 'newshebei',
          hidden: true,
          component: () => import('./pages/systemmanage/admin/newshebei.vue'), // 设备列表
        },
        {
          hidden: true,
          path: '/system/addcompany',
          name: 'addcompany',
          component: () => import('./pages/systemmanage/admin/addcompany.vue'), // 添加公司
        },
        {
          path: '/system/newshebei',
          name: 'newshebei',
          hidden: true,
          component: () => import('./pages/systemmanage/admin/newshebei.vue'), // 设备列表
        },
        {
          path: '/system/upshebei',
          name: 'upshebei',
          hidden: true,
          component: () => import('./pages/systemmanage/admin/upshebei.vue'), // 设备列表
        },
        {
          path: '/system/newcompany',
          name: 'newcompany',
          hidden: true,
          component: () => import('./pages/systemmanage/admin/newcompany.vue'), // 新建公司
        },

        {
          path: '/system/newdictiona',
          name: 'newdictiona',
          hidden: true,
          component: () => import('./pages/systemmanage/dictiona/newdictiona.vue'), // 新增编辑编码字典
        },
        {
          path: '/system/editdictiona',
          name: 'editdictiona',
          hidden: true,
          component: () => import('./pages/systemmanage/dictiona/editdictiona.vue'), // 编辑编码字典
        },

        {
          path: '/system/addStreet',
          name: 'addStreet',
          hidden: true,
          component: () => import('./pages/systemmanage/Street/addStreet.vue'), // 添加街道
        },
        {
          path: '/system/addJurisdiction',
          name: 'addJurisdiction',
          hidden: true,
          component: () => import('./pages/Jurisdiction/addJurisdiction.vue'), // 修改权限信息
        },
        {
          path: '/system/updatacompany/:comid',
          name: 'updatacompany',
          hidden: true,
          component: () => import('./pages/systemmanage/admin/updatacompany.vue'), // 修改公司
        },
        {
          path: '/system/searchDevice',
          name: 'searchDevice',
          meta: {
            icon: 'icon iconfont icon-sousuo',
            title: '查询设备',
          },
          component: () => import('./pages/searchDevice/searchDevice.vue'), // 查询设备
        },
      ],
    },
  ],
});

/** 路由守卫 */
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    // 如果当前是登录就直接到转
    next();
  } else {
    // 如果是其他就 先判断是否有登录信息
    if (localStorage.getItem('AC_USER_INFO') && sessionStorage.getItem('AC_ACCESS_TOKEN')) {
      // 判断是路由否有权限设置
      if (typeof to.matched[0].meta.permission !== 'undefined') {
        // 判断登录信息权限和路由权限  ****以后对应接口可用大于等于****
        if (JSON.parse(localStorage.getItem('AC_USER_INFO')).type === to.matched[0].meta.permission) {
          next(); // 权限对应就直接跳转
        } else {
          next('/');
        }
      } else {
        next(); // 路由没有权限设置就跳对应页
      }
    } else {
      // 没有登录信息就跳转登录页
      next('/login');
    }
  }
});

export default router;
